"use client";
import React, { useState } from "react";
import Slider from "react-slick";
import { ServiceIcon1 } from "@/assets";
import Image from "next/image";
import { fontSizes } from "@/constants/constants";

const CardCarousel = ({services}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const benefits = [
    {
      id: 1,
      icon: ServiceIcon1,
      title: "Brand Consistency",
      description:
        "We Ensure That Every Piece Of Content Reflects Your Brand's Tone, Style, And Messaging, Fostering A Cohesive Identity Across All Channels",
    },
    {
      id: 2,
      icon: ServiceIcon1,
      title: "Enhanced Engagement",
      description:
        "Tailored Content That Speaks Directly To Your Audience Increases Engagement, Builds Trust, And Drives Conversions",
    },
    {
      id: 3,
      icon: ServiceIcon1,
      title: "Strategic Alignment:",
      description:
        "Our Solutions Are Designed To Meet Your Specific Business Goals, Aligning Content Initiatives With Broader Marketing Strategies",
    },
    {
      id: 4,
      icon: ServiceIcon1,
      title: "Professional Excellence",
      description:
        "High-quality content creation that maintains professional standards while delivering exceptional results for your business",
    },
    {
      id: 5,
      icon: ServiceIcon1,
      title: "Data-Driven Results",
      description:
        "Our approach is backed by analytics and performance metrics to ensure your content delivers measurable business impact",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: "0px",
    beforeChange: (current, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "0px",
        },
      },
    ],
  };

  // Function to determine if a slide should have active styling (only center slide)
  const isActiveSlide = (index) => {
    return index === currentSlide;
  };

  return (
    <div className=" py-8 ">
      {/* Slider Section */}
      <div className="relative">
        <style jsx global>{`
          .slick-dots {
            bottom: -40px !important;
          }

          .slick-dots li button:before {
            color: #1EA7DB !important;
            font-size: 12px !important;
          }

          .slick-dots li.slick-active button:before {
            color: #1EA7DB !important;
          }

          .slick-prev,
          .slick-next {
            z-index: 1;
          }

          .slick-prev:before,
          .slick-next:before {
            color: #1EA7DB !important;
            font-size: 24px !important;
          }

          .slick-prev {
            left: -40px !important;
          }

          .slick-next {
            right: -40px !important;
          }

          @media (max-width: 768px) {
            .slick-prev {
              left: -10px !important;
            }

            .slick-next {
              right: -10px !important;
            }

            .slick-prev:before,
            .slick-next:before {
              font-size: 20px !important;
            }
          }
        `}</style>

        <Slider {...settings}>
          {services.map((benefit, index) => {
            const isActive = isActiveSlide(index);
            return (
              <div key={benefit.id} className="px-3 py-8">
                <div
                  className={`group relative bg-white rounded-3xl p-7 min-h-[20rem] flex flex-col overflow-hidden transition-all duration-300 border border-[#1EA7DB1A] ${
                    isActive
                      ? "shadow-2xl -translate-y-1.5 ring-1 ring-[#1EA7DB]/30"
                      : "shadow-md hover:shadow-2xl hover:-translate-y-1.5"
                  }`}
                >
                  {/* Step number watermark */}
                  <span className="pointer-events-none absolute -top-3 right-4 select-none font-display text-[92px] font-semibold leading-none text-ink/[0.06]">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  {/* Top row: icon + small step label */}
                  <div className="relative z-10 flex items-center justify-between mb-6">
                    <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-brand-50">
                      <Image
                        src={benefit.icon}
                        alt={benefit.title}
                        className="w-7 h-7 object-contain"
                      />
                    </div>
                    <span className="eyebrow text-gold-deep">
                      Step {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>

                  {/* Heading */}
                  <h3 className="relative z-10 font-display text-xl lg:text-2xl font-semibold text-ink leading-tight mb-3">
                    {benefit.title}
                  </h3>

                  {/* Accent underline */}
                  <span className="relative z-10 block h-[3px] w-9 rounded-full bg-gold mb-4 transition-all duration-300 group-hover:w-16" />

                  {/* Paragraph */}
                  <p className="relative z-10 text-ink-soft text-sm leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default CardCarousel;
